import React, {useEffect} from 'react';
//import PropTypes from 'prop-types';

import Globals, { URLS } from '../../../utility/constants/appConstants';

import { amountFormatter } from '../../../utility/utils/formatter';
import { calculateServiceCount, discCalculate, easyPayAmt } from '../../../utility/features/helpers/serviceDetailsHelper';
import { Link } from 'react-router';

function OneTimeEasyPayService({ isActionEnabled, data, labels, year, serviceDetailsCss }) {
  const { totalServicesCompleted, servicesRemaining, lastServiceDate } = calculateServiceCount(data, year);

  return (
    <React.Fragment>
      <div className='row d-md-none'>
        <div className='col-12 p-0'>
          <hr className='mb-16 mt-0 w-100' />
        </div>
      </div>
      <div className='row d-md-none'>
        <div className={`col-12 ${serviceDetailsCss['gfs-20']}`}>
          <div className='glh-1_2'>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']}`}>
                {labels.servicesCompleted}
              </span>
              <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['text-gray-med']}`}>
                {totalServicesCompleted}
              </span>
            </div>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']}`}>
                {`${labels.servicesRemaining} ${year}`}:
              </span>
              {data.svcLine && <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                {servicesRemaining}
              </span>}
            </div>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']}`}>
                {labels.lastServiceDate}
              </span>
              {data.svcLine && <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                {lastServiceDate}
              </span>}
            </div>
            <div>
              {data.ServiceAgreementType === 'OneTime' && <span className={`${serviceDetailsCss['gfw-3']} ${serviceDetailsCss['service-line']}`}>
                {labels.payAsYouGo}
              </span>}
              {data.ServiceAgreementType === 'EasyPay' &&
                <>
                  <span className={`${serviceDetailsCss['gfw-3']}`}>{labels.enrolledIn}</span>
                  <span className='font-italic'>
                    <span className={`${serviceDetailsCss['gfw-7']}`}>{labels.easytext}</span>{labels.pay}
                  </span></>
              }
              <div />
            </div>
            
          </div>
          <MobileOneTimeEasyPay isActionEnabled={isActionEnabled} data={data} labels={labels} year={year} serviceDetailsCss={serviceDetailsCss} />
        </div>
      </div>
      <div className= {`d-none d-md-flex row mb-16 mb-md-0 mb-lg-16`}>
        <div className={`col-12 col-md d-flex mb-md-16 mb-lg-0`}>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 `}>
              {labels.servicesCompleted}
            </div>
            <div className={`align-items-end d-flex flex-fill ${serviceDetailsCss['gfs-50']} ${serviceDetailsCss['gfw-9']} glh-1 justify-content-center ${serviceDetailsCss['text-gray-med']}`}>
              {totalServicesCompleted}
            </div>
          </div>
        </div>
        <div className={`col-12 col-md d-flex mb-md-16 mb-lg-0`}>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 `}>
              {`${labels.servicesRemaining} ${year}`}:
            </div>
            {data.svcLine && <div
              className={`align-items-end d-flex flex-fill ${serviceDetailsCss['gfs-50']} ${serviceDetailsCss['gfw-9']} glh-1 justify-content-center ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              {servicesRemaining}
            </div>}
          </div>
        </div>
        <div className={`col-12 col-md d-flex mb-md-16 mb-lg-0`}>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 `}>
              {labels.lastServiceDate}
            </div>
            {data.svcLine && <div
              className={`align-items-end d-flex flex-fill ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-9']} glh-1 justify-content-center ${serviceDetailsCss['pb-12']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              {lastServiceDate}
            </div>}
          </div>
        </div>
        <OneTimeEasyPay isActionEnabled={isActionEnabled} serviceDetailsCss={serviceDetailsCss} data={data} labels={labels} year={year} /> 
      </div>
    </React.Fragment>
  );
}

function OneTimeEasyPay({ isActionEnabled, data, labels, year, serviceDetailsCss }) {
  const { eDate, eDollar, eCent } = easyPayAmt(data, year);
  const { dollars, cents } = amountFormatter(data.arBalance);
  const { discAmount, prePaydiscFlag } = discCalculate(data);
  const queryString = window.location.search !== ""?window.location.search:"";
  return (
    <React.Fragment>
      {(data.ServiceAgreementType === 'OneTime') &&
        <React.Fragment>
          <div className={`col-12 col-md d-flex mb-md-16 mb-lg-0`}>
            <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column glh-1_1 p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
              <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} ${serviceDetailsCss['glh-1_2']}`}>
                {labels.payAsYouGo}
              </div>
              <div className='align-items-center d-flex flex-column flex-fill justify-content-end'>
                <div className={`${serviceDetailsCss['gfs-16']}`}>
                  {labels.amountDue}
                </div>
                {data.svcLine && <div className={`d-block ${serviceDetailsCss['gfs-50']} ${serviceDetailsCss['gfs-md-40']} ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['glh-1_2']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                  {dollars && <><span>${dollars}</span>
                    <sup className={`${serviceDetailsCss['gfs-md-22']}`}>
                      {cents}
                    </sup></>}
                </div>}
              </div>
            </div>
          </div>
          <div className='align-content-between col-12 col-md-4 col-lg-3 col-xl d-flex flex-wrap glh-1_1 mb-md-16 mb-lg-0 mt-lg-16 mt-xl-0'>
            {(dollars !== '0' && cents !== '00') && (
              <React.Fragment>
                {prePaydiscFlag && <Link
                  to={isActionEnabled?URLS.prePayPayment +queryString:""}
                  className={`${serviceDetailsCss['bg-yellow']} align-items-center d-flex p-2 w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}
                >
                  <div className='text-center'>
                    <span className={`${serviceDetailsCss['font-28']} d-inline-block font-italic text-center`}>
                      <strong className={`${serviceDetailsCss['gfw-7']}`}>
                        {labels.pre}
                      </strong>
                      {labels.pay}
                    </span>
                    <span className={`d-inline-block ${serviceDetailsCss['gfs-14']} text-center`}>
                      {labels.pandsave} {Globals.currencySymbol}{parseFloat(discAmount).toFixed(2)}
                    </span>
                  </div>
                </Link>}

                <Link to={isActionEnabled?URLS.easyPayPayment +queryString:""} className={`align-items-center bg-gray-300 d-flex p-5 text-white w-100 tg-ht-60 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}>
                  <div className={`${serviceDetailsCss['gfs-16']} text-center`}>
                    <span> {labels.easypayenroll} &nbsp;</span>
                    <span className={`font-italic ${serviceDetailsCss['gfs-24']}`}>
                      <strong className={`${serviceDetailsCss['gfw-7']}`}>{labels.easytext}</strong>{labels.pay}
                    </span>
                  </div>
                </Link>
              </React.Fragment>
            )}
          </div>

        </React.Fragment>
      }
      {(data.ServiceAgreementType === 'EasyPay') &&
        <React.Fragment>
          <div className={`col-12 col-md d-flex mb-md-16 mb-lg-0`}>
            <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column glh-1_1 p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>

              <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 `}>
                {labels.enrolledIn} <br />
                <span className='font-italic'>
                  <strong className={`${serviceDetailsCss['gfw-7']}`}>
                    {labels.easytext}
                  </strong>
                  {labels.pay}
                </span>
              </div>
              <div className='align-items-center d-flex flex-column flex-fill justify-content-end pb-2'>
                <span className={`d-block ${serviceDetailsCss['gfs-16']} ${serviceDetailsCss['gfw-3']}`}>
                  {labels.lastInvoice}
                </span>
                {data.svcLine && eDate !== 'N/A' &&
                  <span className={`d-block ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                    <span className={`${serviceDetailsCss['gfs-16']}`}>${eDollar}</span>
                    <sup className='gfs-10'>{eCent}</sup>
                  </span>
                }
              </div>
              {eDate && <div>
                {(eDate !== 'N/A') && <span className={`d-block ${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']}`}>
                  {labels.onText}
                </span>}
                {data.svcLine && <span className={`d-block ${serviceDetailsCss['gfs-16']} ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                  {eDate}
                </span>}
              </div>}
            </div>
          </div>
          <div className='align-content-between col-12 col-md-4 col-lg-3 col-xl d-flex flex-wrap glh-1_1 mb-md-16 mb-lg-0 mt-lg-16 mt-xl-0'>
            {prePaydiscFlag && <Link
              to={isActionEnabled?URLS.prePayPayment +queryString:""}
              className={`${serviceDetailsCss['bg-yellow']} align-items-center d-flex p-2 w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}
            >
              <div className='text-center'>
                <span className={`${serviceDetailsCss['font-28']} d-inline-block font-italic text-center`}>
                  <strong className={`${serviceDetailsCss['gfw-7']}`}>
                    {labels.pre}
                  </strong>
                  {labels.pay}
                </span>
                <span className={`d-inline-block ${serviceDetailsCss['gfs-14']} text-center`}>
                  {labels.pandsave} {Globals.currencySymbol}{parseFloat(discAmount).toFixed(2)}
                </span>
              </div>
            </Link>
            }

            <Link
              to={isActionEnabled?URLS.easyPaySettings +queryString:""}
              className={`${serviceDetailsCss['bg-gray-300']} align-items-center d-flex p-2 text-white w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}
            >
              <div className={`${serviceDetailsCss['gfs-16']} text-center`}>
                <span >{labels.manageText} </span>
                <span className='font-italic'>
                  <strong className={`${serviceDetailsCss['gfw-7']}`}>{labels.easytext}</strong>
                  {labels.pay}</span>&nbsp;
                <span>{labels.preferences}</span>
              </div>
            </Link>
          </div>

        </React.Fragment>
      }
    </React.Fragment>

  );
}

function MobileOneTimeEasyPay({ isActionEnabled, data, labels, year, serviceDetailsCss }) {
  const { eDate, eDollar, eCent } = easyPayAmt(data, year);
  const { dollars, cents } = amountFormatter(data.arBalance);
  const { discAmount, prePaydiscFlag } = discCalculate(data);
  const queryString = window.location.search !== ""?window.location.search:"";
  return (
    <React.Fragment>
      {(data.ServiceAgreementType === 'OneTime') && (<React.Fragment>
        <div className='glh-1_2 mb-16'>
          <span className={`d-block ${serviceDetailsCss['gfw-3']}`}>
            {labels.lastInvoice}
          </span>
          {data.svcLine && eDate !== 'N/A' &&
            <span className={`d-block ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              ${eDollar}
              <sup>
                {eCent}
              </sup>
            </span>}

          {eDate && <React.Fragment> {(eDate !== 'N/A') && <span className={`d-block ${serviceDetailsCss['gfw-3']}`}>{labels.onText}</span>}
            {data.svcLine && <span className={`d-block ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              {eDate}
            </span>}</React.Fragment>}
        </div>
        {(dollars !== '0' && cents !== '00') &&
          <React.Fragment>
            <div className='text-center'>
              {prePaydiscFlag && <Link to={isActionEnabled?URLS.prePayPayment +queryString:""} className={`btn btn-outline ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-3']} mb-10 ${serviceDetailsCss['mobile-service-pay-btn']} px-5 text-yellow w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}>
                <span className='font-italic'>
                  <span className={`${serviceDetailsCss['gfw-7']}`}>{labels.pre}</span>{labels.pay}
                </span>&nbsp;
                {labels.pandsave} {Globals.currencySymbol}{parseFloat(discAmount).toFixed(2)}
              </Link>
              }

              <Link to={isActionEnabled?URLS.easyPayPayment +queryString:""} className={`btn btn-outline ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-3']} mb-10 ${serviceDetailsCss['mobile-service-pay-btn']} px-5 ${serviceDetailsCss['text-gray-med']} w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}>
                {labels.manageText}
                <span className='font-italic'>{labels.easypayenroll}
                </span>&nbsp;
                <span className={`${serviceDetailsCss['gfw-7']}`}>{labels.easytext}</span>{labels.pay}
              </Link>
            </div></React.Fragment>}
      </React.Fragment>)
      }

      {(data.ServiceAgreementType === 'EasyPay') && (<React.Fragment>
        <div className='glh-1_2 mb-16'>
          <span className={`d-block ${serviceDetailsCss['gfw-3']}`}>
            {labels.lastInvoice}
          </span>
          {data.svcLine && eDate !== 'N/A' &&
            <span className={`d-block ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              ${eDollar}
              <sup>
                {eCent}
              </sup>
            </span>}

          {eDate && <React.Fragment> {(eDate !== 'N/A') && <span className={`d-block ${serviceDetailsCss['gfw-3']}`}>{labels.onText}</span>}
            {data.svcLine && <span className={`d-block ${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              {eDate}
            </span>}</React.Fragment>}
        </div>
        <div className='text-center'>
          {prePaydiscFlag && <Link to={isActionEnabled?URLS.prePayPayment+queryString:""} className={`btn btn-outline ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-3']} mb-10 ${serviceDetailsCss['mobile-service-pay-btn']} px-5 text-yellow w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}>
            <span className='font-italic'>
              <span className={`${serviceDetailsCss['gfw-7']}`}>{labels.pre}</span>{labels.pay}
            </span>&nbsp;
            {labels.pandsave} {Globals.currencySymbol}{parseFloat(discAmount).toFixed(2)}
          </Link>
          }
          <Link to={isActionEnabled?URLS.easyPaySettings+queryString:""} className={`btn btn-outline ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-3']} mb-10 ${serviceDetailsCss['mobile-service-pay-btn']} px-5 ${serviceDetailsCss['text-gray-med']} w-100 ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}>
            {labels.manageText}
            <span className='font-italic'>
              <span className={`${serviceDetailsCss['gfw-7']}`}>{labels.easytext}</span>{labels.pay}
            </span>&nbsp;
            {labels.preferences}
          </Link>
        </div>
      </React.Fragment>)
      }


    </React.Fragment>

  );
}

export {
  OneTimeEasyPayService,
  OneTimeEasyPay,
  MobileOneTimeEasyPay
};